import { SECTION_HEADING_CLASSNAME } from '@theme/utils/constants';
import React from 'react';

export interface HeadingProps {
  text?: string;
  className?: string;
  as?: React.ElementType;
  children?: React.ReactNode;
}

const SectionHeading: React.FC<HeadingProps> = ({ text, className = '', as, children, ...props }) => {
  const Component: React.ElementType = as || 'h2';
  return (
    <Component
      className={`text-headingSm md:text-headingMd text-sectionHeading section-heading ${SECTION_HEADING_CLASSNAME} ${className}`}
      font-customisation="section-heading"
      color-customisation="page-heading"
      {...props}
    >
      <>
        {text ? text : null}
        {children ? children : null}
      </>
    </Component>
  );
};

export default SectionHeading;
